import { render, staticRenderFns } from "./CompanySector.vue?vue&type=template&id=0e3f7a92&scoped=true&"
import script from "./CompanySector.vue?vue&type=script&lang=js&"
export * from "./CompanySector.vue?vue&type=script&lang=js&"
import style0 from "./CompanySector.vue?vue&type=style&index=0&id=0e3f7a92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e3f7a92",
  null
  
)

export default component.exports